export default __webpack_public_path__ + "static/media/bee-in-box.f975e739.png";